import * as React from 'react';
import { SVGProps } from 'react';

const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M27.807 12.14a1.302 1.302 0 1 0 0-2.604 1.302 1.302 0 0 0 0 2.605Z"
    />
    <path
      fill={props.fill}
      d="M35.615 34.255H9.609v-5.177h20.803l5.203 5.177Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M9.583 6.375h20.834a4.458 4.458 0 0 1 4.458 4.458V21.25a4.458 4.458 0 0 1-4.458 4.458H9.583a4.458 4.458 0 0 1-4.458-4.458V10.833a4.458 4.458 0 0 1 4.458-4.458Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M16.795 11.1a5.765 5.765 0 1 1 6.4 9.59 5.765 5.765 0 0 1-6.4-9.59Z"
    />
    <path
      fill="currentColor"
      d="M19.995 18.516a2.62 2.62 0 1 0 0-5.24 2.62 2.62 0 0 0 0 5.24Zm5.208 7.89H14.786v2.604h10.417v-2.604Z"
    />
  </svg>
);

export default SvgCamera;
